<template>
  <footer>
    <div class="footer-content">
      <div class="footer-left">
        <a
          href="mailto:hello@jakewelch.design"
          target="_blank"
          aria-label="Email"
        >
          <oh-vue-icon name="hi-mail" class="footer-icon" />
        </a>
        <a
          href="https://www.instagram.com/jake___welch/"
          target="_blank"
          aria-label="Instagram"
        >
          <oh-vue-icon name="bi-instagram" class="footer-icon" />
        </a>
        <a
          href="https://github.com/jake-welch-design"
          target="_blank"
          aria-label="GitHub"
        >
          <oh-vue-icon name="bi-github" class="footer-icon" />
        </a>
      </div>

      <div class="footer-right">
        <a
          class="submission-link"
          href="https://forms.gle/QHPDNPtec4yFMwLu5"
          target="_blank"
          >Submit a restroom
        </a>
        <a href="#" class="about" @click.prevent="openColophon">About</a>
        © 2025 Jake Welch
      </div>
    </div>
    <About v-if="isColophonOpen" @close="closeColophon" />
  </footer>
</template>

<script>
  import About from './About.vue';
  import { OhVueIcon } from 'oh-vue-icons';

  export default {
    name: 'Footer',
    components: {
      About,
      OhVueIcon,
    },

    data() {
      return {
        isColophonOpen: false,
      };
    },
    methods: {
      openColophon() {
        this.isColophonOpen = true;
      },
      closeColophon() {
        this.isColophonOpen = false;
      },
    },
  };
</script>

<style scoped>
  footer {
    position: relative;

    background-color: var(--color-1-solid);
    color: var(--color-2-solid);
    border-top: 0.5px solid var(--color-2-solid);

    width: 100%;

    /* padding-right: 1.5em; */

    font-family: satoshi;
    /* font-size: 14px; */
  }

  .footer-content {
    padding: 0.25rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .footer-icon {
    height: 20px;
    width: auto;
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.5em;
    color: white;
  }

  .footer-left a {
    margin-left: 0;
    padding-right: 0.6em;
    color: var(--color-2-solid);
    text-decoration: underline;
    font-size: 14px;
  }

  .footer-left a:hover {
    color: var(--color-3-hilighted);
  }

  .footer-right a.submission-link {
    padding: 0 0.25rem;
    margin-right: 0.5rem;
    color: var(--color-2-solid);
    text-decoration: underline;
    font-size: 14px;
    background-color: var(--color-1-solid);
    cursor: pointer;
  }
  .footer-right a.submission-link:hover {
    color: var(--color-3-hilighted);
    background-color: var(--color-1-solid);
  }

  .footer-right {
    text-align: right;
  }

  .footer-right a {
    padding: 0 0.25rem;
    margin-right: 0.5rem;
    background-color: var(--color-2-solid);
    color: var(--color-1-solid);
    text-decoration: none;
    cursor: pointer;
  }

  .footer-right a:hover {
    background-color: red;
    color: white;
  }

  @media (max-width: 600px) {
    .footer-content,
    .footer-left a,
    .footer-right a.submission-link {
      font-size: 10px;
    }
    .footer-content {
      padding: 0.25rem 0.75rem;
    }
  }
</style>
